import React, { memo } from 'react';

// UI Components
import { GIButton } from 'app-components';

// Types & Config
import { IViewButtonProps } from '../planSummary.types';
import { configs } from '../../../../constants/configs/configs';

// Styles
import { StyleViewBenefitContainer } from '../plansummary.styled';

const ViewBenefitButton = memo(({ coverageStartDate, planId }: IViewButtonProps) => {
    const getViewBenefitDetailsUrl = () => {
        return configs.routes.VIEW_PLAN_INFO
            .replace(':coverageStartDate', coverageStartDate.replace(/\//g, ''))
            .replace(':planId', planId);
    };

    return (
        <StyleViewBenefitContainer>
            <a
                data-testid="viewBenefitDetailsBtn"
                target="_blank"
                rel="noopener noreferrer"
                href={getViewBenefitDetailsUrl()}
            >
                <GIButton
                    id="view_benefit_details_btn"
                    data-testid="view-benefit-button"
                    labelId="plansummary.viewbenefitdetails"
                />
            </a>
        </StyleViewBenefitContainer>
    );
});

ViewBenefitButton.displayName = 'ViewBenefitButton';
export default ViewBenefitButton;
